import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, FileText, Image, HelpCircle, BookOpen, Newspaper, Inbox, Settings, Users, LogOut, Languages, Search, Megaphone, CalendarDays } from "lucide-react";
import { clearToken, api } from "../../lib/api";

export default function AdminLayout() {
  const nav = useNavigate();
  const [me, setMe] = React.useState(null);

  React.useEffect(() => {
    api.me().then(setMe).catch(() => { clearToken(); nav("/admin/login"); });
  }, []);

  const items = [
    { to: "/admin", end: true, label: "Dashboard", icon: LayoutDashboard },
    { to: "/admin/pages", label: "Seiten", icon: FileText },
    { to: "/admin/media", label: "Mediathek", icon: Image },
    { to: "/admin/faq", label: "FAQ", icon: HelpCircle },
    { to: "/admin/glossary", label: "Glossar", icon: BookOpen },
    { to: "/admin/news", label: "Aktuelles", icon: Newspaper },
    { to: "/admin/events", label: "Veranstaltungen", icon: CalendarDays },
    { to: "/admin/press", label: "Presse", icon: Megaphone },
    { to: "/admin/pricing", label: "Preisliste", icon: FileText },
    { to: "/admin/submissions", label: "Anfragen", icon: Inbox },
    { to: "/admin/translations", label: "Übersetzungen", icon: Languages },
    { to: "/admin/seo", label: "SEO & KI", icon: Search },
    { to: "/admin/users", label: "Nutzer", icon: Users },
    { to: "/admin/settings", label: "Einstellungen", icon: Settings },
  ];

  const logout = () => { clearToken(); nav("/admin/login"); };

  return (
    <div className="admin-shell min-h-screen bg-white text-[var(--ink)]" data-testid="admin-layout">
      <aside className="admin-sidebar fixed top-0 left-0 h-screen w-[260px] p-6 flex flex-col gap-1 z-40" aria-label="Adminmenü">
        <div className="mb-8">
          <div className="font-mono text-[10px] tracking-[0.2em] uppercase opacity-60 mb-1">CMS</div>
          <div className="font-cond text-2xl font-black uppercase tracking-tight">Dr. B.-Digitec</div>
        </div>
        {items.map((i) => (
          <NavLink
            key={i.to}
            to={i.to}
            end={i.end}
            data-testid={`admin-nav-${i.label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 border-2 border-transparent font-mono text-[12px] tracking-[0.16em] uppercase ${
                isActive ? "bg-[var(--ink)] text-white border-[var(--ink)]" : "hover:border-[var(--ink)]"
              }`
            }
          >
            <i.icon size={14} /> <span>{i.label}</span>
          </NavLink>
        ))}
        <div className="mt-auto pt-6 border-t-2 border-[var(--ink)] text-xs">
          <div className="font-mono opacity-60 mb-1">EINGELOGGT</div>
          <div className="font-semibold">{me?.name}</div>
          <div className="font-mono text-[10px] opacity-70 break-all">{me?.email}</div>
          <button onClick={logout} data-testid="admin-logout" className="mt-4 flex items-center gap-2 font-mono text-[11px] tracking-[0.16em] uppercase underline">
            <LogOut size={12}/> Abmelden
          </button>
        </div>
      </aside>
      <main className="ml-[260px] p-8 md:p-12">
        <Outlet />
      </main>
    </div>
  );
}
